import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserPatch = {
    path: "/user",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationUserPatch };
